import { useCallback } from 'react';
import { useDocumentationApiFacade } from '../../../apis/facades/useDocumentationApiFacade';
import { addConfigurationItem } from '../../../reducers/documentation/documentationReducer';
import { telemetry } from '../../../telemetry';
import { useDispatch } from 'react-redux';
import { createConfigurationItemFromParserResponseItem } from '../../parser/parserUtils';
import { LAYOUT } from '@server/parser';

export const useLayouts = () => {
  const dispatch = useDispatch();
  const { get_layout } = useDocumentationApiFacade();

  const fetchLayoutData = useCallback(
    async (metadataId: string, crmOrgId: string) => {
      try {
        const response = await get_layout(metadataId);
        const newConfigurationItem = createConfigurationItemFromParserResponseItem({
          responseItem: response,
          objectApiName: response.objectName,
          keyType: LAYOUT,
        });
        dispatch(
          addConfigurationItem({
            crmOrgId,
            newConfigurationItem,
          }),
        );
        return newConfigurationItem;
      } catch (error) {
        telemetry.captureError(`Error during layout fetch for metadataId ${metadataId}`, error);
      }
    },
    [get_layout, dispatch],
  );

  return { fetchLayoutData };
};
